export default {"src":"/_next/static/media/sparkleBlue.07afb157.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};